import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { User } from "./user";
import { environment } from '../../environments/environment';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class UserService {

  constructor(private http:Http) {
  }

  public login(user:User):Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({headers: headers, withCredentials: true});

    return this.http.post(environment.urls.loginUser, JSON.stringify(user), options);
  }

  public checkSession():Observable<any> {
    let options = new RequestOptions({withCredentials: true});

    return this.http.get(environment.urls.loginUser, options);
  }

  public getAllUsers():Observable<any> {
    let options = new RequestOptions({withCredentials: true});

    return this.http.get(environment.urls.getAllUser, options)
      .map(res => res.json() || {});
  }

  public deleteUser(user):Observable<any> {
    let options = new RequestOptions({withCredentials: true});

    return this.http.delete(environment.urls.deleteUser + '/' + user.username, options);
  }

  public createUser(user):Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let options = new RequestOptions({headers:headers, withCredentials: true});

    return this.http.post(environment.urls.createUser, JSON.stringify(user), options);
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user.service.ts